// extracted by mini-css-extract-plugin
module.exports = {"UserIcon":"UserIcon_UserIcon__qOX6f","Clickable":"UserIcon_Clickable__Ux45y"};